import {GlasContainerSearchForm} from "./GlasContainerSearchForm.js";
const glasContainerForm = new GlasContainerSearchForm();
glasContainerForm.initGlasContainerSearch();
